import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";

export default class APIGroupId extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postAddMember = async (
    groupId: UUID,
    { userId }: { userId: UUID },
  ): Promise<any> => {
    let res = await this._fetch({
      url: `/groups/${groupId}/add_member`,
      method: "POST",
      params: { user_id: userId },
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
